function showTablePopup(land) {

    removeopup();

    d3.csv("./data/data-travelmap-01-08.csv").then(function(data) {

        var doek = document.getElementById('doek');

        // <div id="popup" class="table">
        popup = document.createElement('div');
        popup.id = 'popup';
        popup.className = 'table';
        doek.appendChild(popup);
                
        animatePopupIn(popup);
        createCloseButton(popup);

        titlePopup(popup, land);
        // comments(popup);
        tablePopups(popup, land, data);
    });
}